import { OccurrenceTopicResponse } from "../contracts/OccurrenceTopicResponse";
import { ProgressResponse } from "../contracts/ProgressResponse";
import { SessionTopicPlanResponse } from "../contracts/SessionTopicPlanResponse";
import { TopicProgressResponse } from "../contracts/TopicProgressResponse";
import { TopicRefResponse } from "../contracts/TopicRefResponse";
import { Progress, TopicProgress } from "../models/Progress";
import { OccurrenceTopic, SessionTopicPlan, TopicRef } from "../models/TopicPlan";

export const mapResponseToTopicRef = (resp: TopicRefResponse): TopicRef => ({
  topicId: resp.topicId,
  programmeId: resp.programmeId,
  code: resp.code,
  title: resp.title,
  kind: resp.kind,
});

export const mapResponseToSessionTopicPlan = (resp: SessionTopicPlanResponse): SessionTopicPlan => ({
  bookingId: resp.bookingId,
  anchorDate: resp.anchorDate,
  topics: (resp.topics ?? []).map(mapResponseToTopicRef),
});

export const mapResponseToOccurrenceTopic = (resp: OccurrenceTopicResponse): OccurrenceTopic => ({
  occurrenceDate: resp.occurrenceDate,
  topic: mapResponseToTopicRef(resp.topic),
  source: resp.source,
});

const mapResponseToTopicProgress = (resp: TopicProgressResponse): TopicProgress => ({
  topicId: resp.topicId,
  code: resp.code,
  title: resp.title,
  kind: resp.kind,
  unitMinutes: resp.unitMinutes,
  requiredCount: resp.requiredCount,
  attendedCount: resp.attendedCount,
  remainingCount: resp.remainingCount,
  lastAttendedOn: resp.lastAttendedOn ?? null,
});

export const mapResponseToProgress = (resp: ProgressResponse): Progress => {
  const topics = (resp.topics ?? []).map(mapResponseToTopicProgress);
  const remainingTopics = topics.filter((t) => t.remainingCount > 0);
  return {
    enrolmentId: resp.enrolmentId,
    programmeId: resp.programmeId,
    programmeName: resp.programmeName,
    licenceClass: resp.licenceClass ?? null,
    isLicenceClassProgramme: resp.isLicenceClassProgramme === true,
    enrolledOn: resp.enrolledOn,
    completedOn: resp.completedOn ?? null,
    theoryRequired: resp.theoryRequired,
    theoryDone: resp.theoryDone,
    practicalRequired: resp.practicalRequired,
    practicalDone: resp.practicalDone,
    topics,
    remainingTopics,
    isComplete: remainingTopics.length === 0,
    recordAvailable: resp.recordAvailable === true,
    signedOn: resp.signedOn ?? null,
  };
};
